import { useEffect, useState } from 'react';
import { useClubContext } from './ClubContext';

const useSignupModal = (): { 'data-signup-trigger'?: true } => {
    const { isOpenClubEnabled } = useClubContext();
    const [signupModalTrigger, setSignupModalTrigger] = useState<{ 'data-signup-trigger'?: true }>({});
    useEffect(() => {
        if (isOpenClubEnabled) {
            setSignupModalTrigger({ 'data-signup-trigger': true });
        }
    }, [isOpenClubEnabled]);

    return signupModalTrigger;
};

export default useSignupModal;
